// extracted by mini-css-extract-plugin
module.exports = {"agGridWrapper":"RatingsTable_agGridWrapper__bOh_b","reChartsWrapper":"RatingsTable_reChartsWrapper__J5PF5","recharts-wrapper":"RatingsTable_recharts-wrapper__L2zmA"};